import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-6 border-b border-gray-400 min-h-[4.5rem]" }
const _hoisted_2 = { class: "pb-6 border-b border-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackendFilters = _resolveComponent("BackendFilters")!
  const _component_ChartGrid = _resolveComponent("ChartGrid")!
  const _component_CoursesTable = _resolveComponent("CoursesTable")!
  const _component_RegionsTable = _resolveComponent("RegionsTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BackendFilters, { "include-courses": "" })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_ChartGrid)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CoursesTable)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_RegionsTable)
      ])
    ])
  ]))
}